import { render, staticRenderFns } from "./WagonWheelsets.vue?vue&type=template&id=16c3117e"
import script from "./WagonWheelsets.vue?vue&type=script&lang=js"
export * from "./WagonWheelsets.vue?vue&type=script&lang=js"
import style0 from "./WagonWheelsets.vue?vue&type=style&index=0&id=16c3117e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports